import React, { useEffect, useState } from 'react'

import { CalculatorContainerBlock } from 'Blocks/Main/CalculatorContainerBlock'
import { useQueryParams } from 'Hooks'

import ArrowLeftSVG from 'SVGs/arrow-left.svg'
import ChevronRight from 'SVGs/chevronRight.svg'

const DesktopTabSelection = ({ tabNames, mainContentArea, desktopActiveIndex, setDesktopActiveIndex, calculatorFromUrl }) => {
  if (tabNames?.length === 0) return null

  const [wasTabClicked, setWasTabClicked] = useState(false)

  function onTabNameClicked(tab, index) {
    setDesktopActiveIndex(index)
    setWasTabClicked(true)
  }

  function onKeyDown(e, index) {
    if (e.keyCode === 13) {
      onTabNameClicked(null, index);
    }
  }

  return (
    <>
      <div className="hidden lg:block">
        <div className="container mx-auto max-w-screen-xl">
          <div className='flex border-b-2 border-gray-300 xl:ml-24 lg:ml-20 md:ml-12'>
            {tabNames?.map((item, i) => (
              <div tabIndex={0}
                  key={i}
                  onClick={() => onTabNameClicked(item, i)}
                  onKeyDown={(e) => onKeyDown(e, i)}
                  className={`${i === desktopActiveIndex ? 'border-fuchsia' : 'border-transparent'} border-b-2 pb-2 mr-8 ml-2 md:ml-0 hover:text-gray-600 cursor-pointer text-base lg:text-lg font-display`}>
                {item}
              </div>
            ))}
          </div>
        </div>
        <div data-epi-edit="MainContentArea">
          {mainContentArea?.length > 0 &&
            <CalculatorContainerBlock
              data={mainContentArea[desktopActiveIndex]}
              key={desktopActiveIndex}
              isMobile={false}
              calculatorFromUrl={calculatorFromUrl}
              wasTabClicked={wasTabClicked}
            />}
        </div>
      </div>
    </>
  )
}

const MobileTabSelection = ({ tabNames, mainContentArea, mobileActiveIndex, setMobileActiveIndex, selectionMade, setSelectionMade, calculatorFromUrl }) => {
  if (tabNames?.length === 0) return null

  function onBackButtonClicked() {
    setSelectionMade(false)
    setMobileActiveIndex(0)
  }

  function onSelectionMadeClicked(tab, index) {
    setSelectionMade(true)
    setMobileActiveIndex(index)
    const parsedUrl = new URL(window.location.href)
    // add to search params
    parsedUrl.searchParams.set('CalculatorType', tab)
    // update url
    window.history.pushState({}, '', parsedUrl)
  }

  return (
    <div className="block lg:hidden">
      {selectionMade && (
        <div className='bg-[#D3D9FF]'>
          <button className='h-[48px] pl-4 pr-8 text-violet'
            onClick={() => onBackButtonClicked()}
          >
            <div className='flex'>
              <div className='flex items-center'>
                <ArrowLeftSVG className="inline-block mx-2" width="20" height="20" />
              </div>
              <div className='font-semibold'>
                Back
              </div>
            </div>
          </button>
        </div>
      )}
      {!selectionMade &&
        <div className="container mx-auto max-w-screen-xl">
          {tabNames?.map((tabName, i) => (
            <div className='' key={i}>
              <div
                className='flex justify-between w-full px-4 py-6 border-b-2 border-gray-300 hover:cursor-pointer hover:bg-gray-100'
                onClick={() => onSelectionMadeClicked(tabName, i)}
              >
                <div className='font-bold text-lg font-display'>{tabName}</div>
                <div className='mr-4'>
                  <ChevronRight className="w-[11px] text-violet" />
                </div>
              </div>
            </div>
          ))}
        </div>
      }
      {selectionMade &&
        <CalculatorContainerBlock
          data={mainContentArea[mobileActiveIndex]}
          isMobile={true}
          tabName={tabNames[mobileActiveIndex]}
          calculatorFromUrl={calculatorFromUrl} />
      }
    </div>
  )
}

const GroupOfCalculatorsBlock = ({ data, inEditMode }) => {
  const { MainContentArea, BackgroundColor } = data
  const queryParams = useQueryParams()

  const [desktopActiveIndex, setDesktopActiveIndex] = useState(0)
  const [mobileActiveIndex, setMobileActiveIndex] = useState(0)
  const [selectionMade, setSelectionMade] = useState(false)
  const [isIndexAlreadySet, setIsIndexAlreadySet] = useState(false)
  const tabNames = MainContentArea?.map(x => x.Title)

  useEffect(() => {
    if (!isIndexAlreadySet && queryParams?.CalculatorType) {
      const index = tabNames.findIndex((tabName) => tabName === queryParams.CalculatorType)
      if (index >= 0) {
        setDesktopActiveIndex(index)
        setMobileActiveIndex(index)
        setSelectionMade(true)
        setIsIndexAlreadySet(true)
      }
    }
  }, [])

  return (
    <div>
      <DesktopTabSelection
        tabNames={tabNames}
        mainContentArea={MainContentArea}
        desktopActiveIndex={desktopActiveIndex}
        setDesktopActiveIndex={setDesktopActiveIndex}
        calculatorFromUrl={queryParams.Calculator}
      />

      <MobileTabSelection
        tabNames={tabNames}
        mainContentArea={MainContentArea}
        mobileActiveIndex={mobileActiveIndex}
        setMobileActiveIndex={setMobileActiveIndex}
        selectionMade={selectionMade}
        setSelectionMade={setSelectionMade}
        calculatorFromUrl={queryParams.Calculator}
      />
    </div>
  )
}

export default React.memo(GroupOfCalculatorsBlock)